export default {
  cardInfo: (state) => state.cardInfo,
  bankCardInfo: (state) => state.bankCardInfo || {},
  moneyNum: (state) => {
    if(!state.moneyNum) return sessionStorage.getItem('AMOUNT_OF_CHARGE');
    return state.moneyNum;
  },
  chargeType: (state) => {
    return state.chargeOptions.chargeType;
  },
  conbiniCode: (state) => {
    return state.chargeOptions.conbiniCode;
  },
  chargeDirectory: (state) => state.chargeOptions.directory,
  delCardStatus: (state) => state.deleteCardStatus,
  bankList: (state) => state.bankList,
};
